import { CardType } from 'types/deck'
import { Option } from 'components/elements/ArchidektDropdown/types'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import ManaSymbol from 'components/misc/customIcons/ManaSymbol'
import PhatButton from 'components/formElements/PhatButton'
import Icon from 'components/elements/Icon'

import { getCardCMC } from 'utils/GetCardCMC'

import styles from './customCmcDropdown.module.scss'

type Props = {
  card: CardType
  onCardUpdate: (updatedCard: CardType) => void
}

const CustomCmcDropdown = ({ card, onCardUpdate }: Props) => {
  const currentCMC = getCardCMC(card)

  const OPTIONS: Option[] = Array.from(Array(16).keys()).map(cmc => ({
    label: <ManaSymbol symbol={cmc} />,
    id: `${cmc}`,
    onClick: () => onCardUpdate({ ...card, customCmc: cmc }),
  }))

  return (
    <ArchidektDropdown options={OPTIONS} menuClassName={styles.menu}>
      <PhatButton className={styles.trigger}>
        <ManaSymbol symbol={currentCMC} />
        <span style={{ color: currentCMC !== card.cmc ? '#fa890d' : '' }}>Custom CMC</span>
        <Icon name="dropdown" />
      </PhatButton>
    </ArchidektDropdown>
  )
}

export default CustomCmcDropdown
